import type { StylePropertiesTypes } from '@wix/document-services-types'
import { isKeyword } from '../../atomics/utils'

export const isSystemFont = (prop: StylePropertiesTypes.Font): prop is StylePropertiesTypes.SystemFont =>
	isKeyword(prop.type)
